export default __webpack_public_path__ + "src/images/packages/hillsneck-safari-lodge/9f700b377341cea8505623d21df5fc9e-HillsNek Evening Pool Time.jpg";